import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import { transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import { PROMO_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYOUT_COUNTRY, PAYOUT_METHOD, SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { METHOD_SUGGESTION } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';

const PayoutStoriesModal = ({ sliders, popupFullwidthRef }) => {
    const { deliveryMethod, toCountry } = useExtra();
    const { continueButton, notNowButton } = usePageMessages();
    const imagesLoaded = usePreloadStoryImages(sliders?.slides);
    const closeStories = () => popupFullwidthRef?.current?.close();
    const amplitudeDeliveryMethod = transactionMethods[deliveryMethod];
    const hasTopButton = sliders?.not_now;

    useEffect(() => {
        amplitude.getInstance().logEvent(PROMO_SCREEN_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [SCREEN]: METHOD_SUGGESTION,
        });
    }, []);

    const getSteps = () => {
        return sliders.slides?.map((slide) => (
            <StoryLayout
                key={slide.order}
                topButtonCaption={hasTopButton ? notNowButton : null}
                onTopButtonClick={closeStories}
                title={slide.title}
                subtitle={<DangerouslyHtml dangerouslyHtml={slide.subtitle} />}
                variant="secondary_base"
                bottomButtonCaption={continueButton}
                imgA={slide.web_a_bg_img_url}
                imgA2x={slide.web_a2x_bg_img_url}
                imgB={slide.web_b_bg_img_url}
                imgB2x={slide.web_b2x_bg_img_url}
                contentPosition={slide.position}
                onBottomButtonClick={() => {
                    closeStories();
                }}
            />
        ));
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} duration={sliders.duration * 1000} isInverted />}</>;
};

export default PayoutStoriesModal;
